import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoutesPath } from '@shared/constants';
import { AuthData } from '@shared/services/auth';
import { map } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authData = inject(AuthData);
  return authData.isAuthenticated().pipe(
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        return router.createUrlTree([RoutesPath.LOGIN]);
      }
      return true;
    })
  );
};
